import React, { useEffect, useState } from "react";
import { Redirect, Route, useLocation, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import authManager from "../services/authManager";

const PrivateRoute = ({ component: Component, selectedEvent, ...rest }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const location = useLocation();
    const { t } = useTranslation();

    // ✅ Autenticación simplificada usando AuthManager
    useEffect(() => {
        authManager.isAuthenticated()
            .then(() => setIsAuthenticated(true))
            .catch(() => setIsAuthenticated(false));
    }, []);

    // ✅ Gestión de títulos de página
    useEffect(() => {
        const updateTitle = () => {
            const pathParts = location.pathname.split('/').filter(part => part !== '');  

            let title = 'Revopic'; // Título por defecto

            if (pathParts[0] === 'account') {
                title = t(`account.${pathParts[1]}`, { defaultValue: title });
            } else if (pathParts[0] === 'events') {
                if (pathParts[1] === 'new') {
                    title = t('events.new');
                } else if (pathParts[1] && pathParts[2]) {
                    const eventName = selectedEvent?.name || '';
                    title = t('events.details', { eventName: eventName });
                } else {
                    title = t('events.list');
                }
            } else if (pathParts[0] === 'guide') {
                title = t('guide.documentTitle');
            } else if (pathParts[0] === 'signIn') {
                title = t('signIn');
            } else if (pathParts[0] === 'signUp') {
                title = t('signUp');
            }

            document.title = title;
        };

        updateTitle();
    }, [location.pathname, t, selectedEvent]);  

    // ✅ Manejo de errores específicos en URL
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const error = searchParams.get('error_description');
        
        if (error?.includes('[WARNING] Email already exists:')) {
            alert(t('This email is already registered'));
        }
    }, [location.search, t]);

    // ✅ Estados de carga y redirección simplificados
    const searchParams = new URLSearchParams(location.search);
    const error = searchParams.get('error_description');

    // El arranque se pinta DENTRO del cromo (routerConfig): el Route se devuelve siempre y es
    // su render el que resuelve los cuatro casos, en el mismo orden que antes. Así el raíl y la
    // cabecera son el mismo nodo antes y después de autenticar, y React no los remonta.
    return (
        <Route
            {...rest}
            render={(props) => {
                if (isAuthenticated === null) {
                    return <Component {...props} authPending />;
                }
                if (error?.includes('PreSignUp failed with error This email is already registered') || error?.includes('Email already exists')) {
                    return <Redirect to={"/signIn?error=mail-already-registered"} />;
                }
                return isAuthenticated ? <Component {...props} /> : <Redirect to="/signIn" />;
            }}
        />
    );
};

const mapStateToProps = state => (
    { selectedEvent: state.eventsReducer.selectedEvent }
)

export default withRouter(connect(mapStateToProps)(PrivateRoute));
